export const CONTROLLER_CONSTANTS = {
  URL_LEVER: '/models/lever.glb',
  URL_SWITCH: '/models/Switcher.glb',
  URL_BUTTON: '/models/Button.glb',

  ACCEPTED_VALUE_RANGE_UPPER: 0.65,
  ACCEPTED_VALUE_RANGE_LOWER: 0.55,

  SWEEPS_TO_HIDE: [
    '95be954decbf40c6b80260e69827710a',
    '7e7803557e324dbfbeba918b987559e4',
    '5e3d23d651554cafbfec4dbf9643dbc4',
    'b4ef5c2d62824273ad849a82e5f86e51',
    '1bab6aac9a124c0b82f9d2cd9b25a0f2',
    '83ae1f567a6f410b8f0e0ff90fce1b62',
    '545f056e027045e384c202f607e95f96',
    'eb2c3e35effd4c8ea7b7746c725df799',
    '289785641ad44ac5a10c646f3d3ccb48',
    '2143d1b5218c426a90263aeb0162be33',
    '76f4d0e4ab8c4e9eb307b4e1b4d77ece',
    'f2a558363af348c4bb20c0f63f16c24d',
    'bded41ed99dd446284d336d35e94980e',
    '03056e534fb04625abe7f5aa248c7175',
    '9c4e5b7b3c6b461db13f883e5e6bd281',
    'a8966c7b1d5e41afb09d05db447749a7',
    'bac2845a0d0844e09a193d52bd7ced6e',
    '96f50afe984b4f859ac5a1938aad19a1',
    '389a679beb7e4ab28021ca6065274a3e',
    '2df5d4909ba24fe8a8197ac47f2292be',
    '447ff37eb46145dd895202bf8d256183',
    '49a54b55f2bb4d018a0c3fce325aadd3',
    '77d3bb4490f746059075003305cde5a5',
    '83484340d8eb4e219c3f449f1a4ce6af',
    '8061d8e031f145249071b61e2fce3e8a',
    '1db486b53054407aae2344835207fd30',
    'c6f03c957c574ca597a4affd2a2036b1',
  ],
};
